import React from 'react';
import { CalendarEvent } from '../../types/ics';
import { startOfWeek, addDays, isSameDay, formatDate } from '../../utils/dateUtils';

interface WeekViewProps {
  currentDate: Date;
  events: CalendarEvent[];
  onEventClick: (event: CalendarEvent) => void;
}

export const WeekView: React.FC<WeekViewProps> = ({
  currentDate,
  events,
  onEventClick,
}) => {
  const weekStart = startOfWeek(currentDate);
  const weekDays = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));

  return (
    <div className="grid grid-cols-7 gap-4 min-h-[600px] border rounded-lg">
      {weekDays.map((day, index) => {
        const dayEvents = events.filter(event => isSameDay(event.startDate, day));
        const isToday = isSameDay(day, new Date());

        return (
          <div
            key={index}
            className={`border-r last:border-r-0 ${
              isToday ? 'bg-blue-50' : ''
            }`}
          >
            <div className="p-2 text-center border-b sticky top-0 bg-white">
              <div className="text-sm font-medium text-gray-500">
                {day.toLocaleDateString('en-US', { weekday: 'short' })}
              </div>
              <div className={`text-lg ${isToday ? 'text-blue-600 font-semibold' : ''}`}>
                {day.getDate()}
              </div>
            </div>
            <div className="p-2 space-y-1">
              {dayEvents.map(event => (
                <button
                  key={event.uid}
                  onClick={() => onEventClick(event)}
                  className="w-full text-left text-sm p-1 rounded bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors truncate"
                  title={`${event.summary}\n${formatDate(event.startDate)}`}
                >
                  {event.summary}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};